import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import env from "../../env";

const SsoLogin = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const email =
      params.get("email") ||
      params.get("login_hint") ||
      localStorage.getItem("ssoEmail");

    if (!email) {
      return;
    }

    console.log("params:--------------", params, email);

    const redirectUrl = `${env.apiLink}user/sso-login?email=${encodeURIComponent(
      email,
    )}`;
    window.location.replace(redirectUrl);
  }, [location.search]);

  return (
    <>
      <div className="flex h-screen items-center justify-center">
        <div className="rounded-lg border border-gray-200 bg-white p-6 text-center">
          <p className="text-sm font-semibold text-gray-700">SSO Login</p>
          <p className="mt-2 text-xs text-gray-500">
            Missing email. Please use the invite link or provide an email
            parameter.
          </p>
          <button
            className="mt-4 rounded-md bg-primary px-4 py-2 text-xs text-white"
            onClick={() => navigate("/login")}
          >
            Go to Login
          </button>
        </div>
      </div>
    </>
  );
};

export default SsoLogin;
